/**
 * Persistência da listagem (filtros + paginação) do relato de ocorrência.
 *
 * - Usa `sessionStorage` (mesma aba): sobrevive a F5 e ao voltar de
 *   /novo, /editar e /visualizar, mas não vaza entre abas/sessões.
 * - A URL (`?pagina=`) continua sendo a fonte de verdade quando existe;
 *   este storage é o fallback para refresh e navegação interna.
 */

const CHAVE = "relato_ocorrencia_listagem_v1";
const TTL_MS = 12 * 60 * 60 * 1000; // 12h (guarda contra dado velho)

function storageSeguro() {
  try {
    if (typeof sessionStorage === "undefined") return null;
    return sessionStorage;
  } catch (_e) {
    return null;
  }
}

/**
 * @returns {{ paginaAtual: number, itensPorPagina: number, filtros: Object|null }|null}
 */
export function carregarListagemSalva() {
  const storage = storageSeguro();
  if (!storage) return null;
  try {
    const raw = storage.getItem(CHAVE);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.timestamp && Date.now() - parsed.timestamp > TTL_MS) {
      storage.removeItem(CHAVE);
      return null;
    }
    const paginaAtual =
      Number.parseInt(parsed.paginaAtual, 10) > 0
        ? Number.parseInt(parsed.paginaAtual, 10)
        : 1;
    const itensPorPagina =
      Number.parseInt(parsed.itensPorPagina, 10) > 0
        ? Number.parseInt(parsed.itensPorPagina, 10)
        : 5;
    return {
      paginaAtual,
      itensPorPagina,
      filtros:
        parsed.filtros && typeof parsed.filtros === "object"
          ? parsed.filtros
          : null
    };
  } catch (_e) {
    return null;
  }
}

/**
 * @param {{ paginaAtual: number, itensPorPagina: number, filtros: Object }} estado
 */
export function salvarListagem(estado) {
  const storage = storageSeguro();
  if (!storage) return;
  try {
    storage.setItem(
      CHAVE,
      JSON.stringify({
        paginaAtual: estado.paginaAtual || 1,
        itensPorPagina: estado.itensPorPagina || 5,
        filtros: estado.filtros || null,
        timestamp: Date.now()
      })
    );
  } catch (_e) {
    return;
  }
}

export function limparListagemSalva() {
  const storage = storageSeguro();
  if (!storage) return;
  try {
    storage.removeItem(CHAVE);
  } catch (_e) {
    return;
  }
}

export const LISTAGEM_STORAGE_KEY = CHAVE;
